export const style = {
    py: 0,
    width: "100%",
    maxWidth: 360,
    maxHeight: 400,
    overflowY: "auto",
    borderRadius: 2,
    border: "1px solid",
    borderColor: "divider",
    backgroundColor: "background.paper",
  };